const Color = {
  BLACK: 'black',
  GRAY_DARK: '#3a3a3a',
  WHITE: 'white',
  DARK_ORANGE: 'darkorange',
};

export default Color;
